jQuery(function($) {
  const player = new Plyr('.video-player');
})